import { useEffect, useState } from "react";
import { format } from "date-fns";
import Button from "../../Custom/Button/Button";
import picture1 from "../../picture/1.png";
import eyeIcon from "../../picture/Visible.png";
import eyeNonIcon from "../../picture/VisibleNon.png";
import userIcon from "../../picture/korisnik.png";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import "./notificationList.css";
import { ContentPasteOffSharp } from "@mui/icons-material";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const NotificationList = ({
  currentActive,
  currentNotification,
  setCurrentNotification,
  setIsEditing,
  isEditing,
  setAddNotification,
  notifications,
  setNotificationsList,
  setCurrentSelectedNotification,
}) => {
  const [selectedNotification, setSelectedNotification] = useState(null);
  const { baseUrl, apiKey, loggedUser } = useGlobalContext();
  let changeColor = true;

  const handleSelected = async (set) => {
    console.log(selectedNotification, set, loggedUser);
    if (selectedNotification?.id === set.id) {
      console.log("Poziv ne treba");
      setSelectedNotification(null);
      setAddNotification(false);
      setCurrentNotification({
        id: 0,
        name: "",
        location: "",
        user: "Zikica Petkovic",
        startTime: "",
        endTime: "",
        date: "",
        description: "Ova notifikacija je obavezna",
        comment: [],
        notifyUsers: [],
        alarms: [],
        alarmTime: "",
      });
      setCurrentSelectedNotification(null);
      setIsEditing(false);
    } else {
      console.log("Zove se drugi");
      try {
        const { data } = await axios.post(
          `${baseUrl}/notifications/updateNotifSeen.php`,
          {
            api_key: apiKey,
            user_id: loggedUser.id,
            notification_id: set.id,
          }
        );
        console.log(data);
        if (data.status === 200) {
          setIsEditing(true);
          setSelectedNotification(set);
          setCurrentNotification(set);
          setCurrentSelectedNotification(set);
          //setAddNotification(true);
          setNotificationsList([set]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  console.log(notifications);

  const handleScrollTop = (indexNonActive, indexActive) => {
    const wrapper = document.querySelector(".notification-list");
    const buttonTaskbar = document.querySelectorAll(
      ".button-taskbar-notification"
    )[indexNonActive];

    wrapper.scrollTo(
      0,
      indexActive * buttonTaskbar.getBoundingClientRect().height
    );
  };

  useEffect(() => {
    if (selectedNotification !== null) {
      const indexCurrent = notifications
        ?.map((item) => item.name)
        .indexOf(selectedNotification.name);
      if (indexCurrent !== 0) {
        let indexNonActive;
        if (indexCurrent === notifications.length - 1) {
          indexNonActive = indexCurrent - 1;
        } else {
          indexNonActive = indexCurrent + 1;
        }
        handleScrollTop(indexNonActive, indexCurrent);
      }
    }
  }, [selectedNotification]);

  useEffect(() => {
    if (currentNotification?.name === "") setSelectedNotification(null);
  }, [currentNotification]);

  const handleCountNotify = (data, isVisible) => {
    return data.notifyUsers.filter(
      (item) => item.isVisible === isVisible && item.forNotify
    ).length;
  };

  const resizer = () => {
    const wrapper = document.querySelector(".wrapper-notification-content");
    if (wrapper) {
      const wrapperDim = wrapper.getBoundingClientRect();
      const elements = document.querySelectorAll(
        ".button-taskbar-notification"
      );
      elements.forEach(
        (element) => (element.style.height = `${wrapperDim.height / 5}px`)
      );
    }
  };

  window.addEventListener("resize", resizer);

  useEffect(() => {
    if (notifications.length === 0) return;
    resizer();
    return () => window.removeEventListener("resize", resizer);
  }, [notifications]);

  return (
    <>
      <div className="notification-list">
        {notifications?.map((item, index) => {
          if (index > 0) {
            const day = notifications[index].date.getDay();
            const lastDay = notifications[index - 1].date.getDay();

            if (day !== lastDay) {
              changeColor = !changeColor;
            }
          }

          let location = "";
          if (item.location.length !== undefined) {
            item.location.forEach((element) => {
              if (element.forNotify) location = element;
            });
          } else {
            location = item.location.name;
          }
          console.log(item);
          const correctTime = `${item.startTime} ${
            item.endTime !== "" ? `- ${item.endTime}` : ""
          }`;
          return (
            <div className="button-taskbar-notification-wrapper" key={index}>
              <div
                className="button-taskbar-notification"
                key={index}
                onClick={() => handleSelected(item)}
              >
                <Button
                  active={selectedNotification?.id === item.id ? true : false}
                >
                  {/*<div
                    className={
                      changeColor
                        ? "notification-details par"
                        : "notification-details nepar "
                    }
                  >
                    <div className="notification-time">
                      <span className="button-taskbar-notification-span start-time">
                        {item.startTime}
                      </span>
                      <span className="button-taskbar-notification-span end-time">
                        {item.endTime}
                      </span>
                      <span className="button-taskbar-notification-span date">
                        {format(new Date(), "dd.MM.yy") !== item.date &&
                          format(item.date, "dd.MM.yy")}
                      </span>
                    </div>
                    <div className="notification-name-location-user">
                      <span className="button-taskbar-notification-span name-notification">
                        {item.name}
                      </span>
                      <span className="button-taskbar-notification-span location-notification">
                        {location.name}
                      </span>
                      <span className="button-taskbar-notification-span user-notification">
                        {item.user || item.user.name}
                      </span>
                    </div>
                    <div className="notification-details-edit">
                      <div className="notification-indicator">
                        <div className="notification-indicator-alarm">
                          <NotificationsOutlinedIcon
                            style={{
                              color: "green",
                              width: "80%",
                              aspectRatio: "1/1",
                            }}
                          />
                          <span>{handleCountNotify(item, true)}</span>
                        </div>
                        <div className="notification-indicator-alarm">
                          <NotificationsOutlinedIcon
                            style={{
                              color: "red",
                              width: "80%",
                              aspectRatio: "1/1",
                            }}
                          />
                          <span>{handleCountNotify(item, false)}</span>
                        </div>
                        <div className="notification-indicator-alarm">
                          <img src={picture1} alt=""></img>
                          <span>{item.comment.length}</span>
                        </div>
                      </div>
                      <div
                        className="notification-pen"
                        onClick={() => console.log("Edit")}
                      >
                        <img src={pen} alt="" />
                      </div>
                    </div>
                  </div>*/}
                  <div className="notification-main">
                    <div className="notification-main-part">
                      <span className="notification-main-part-date">
                        {format(item.date, "dd.MM.yy")}
                      </span>
                      <span className="notification-main-part-user">
                        {item.user}
                      </span>
                      <span className="notification-main-part-title">
                        {item.name}
                      </span>
                    </div>
                    <div className="notification-main-part">
                      <span className="notification-main-part-time">
                        {correctTime}
                      </span>
                      <span className="notification-main-part-desc">
                        {item.description}
                      </span>
                      <div className="notification-main-part-buttons">
                        <div className="notification-main-part-item">
                          <img
                            className="notification-main-part-img"
                            src={userIcon}
                            alt=""
                          />
                          <span>5</span>
                        </div>
                        <div className="notification-main-part-item">
                          <img
                            className="notification-main-part-img"
                            src={eyeIcon}
                            alt=""
                          />
                          <span>5</span>
                        </div>
                        <div className="notification-main-part-item">
                          <img
                            className="notification-main-part-img"
                            src={eyeNonIcon}
                            alt=""
                          />
                          <span>5</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Button>
              </div>
              {selectedNotification?.id === item.id && (
                <div className="current-notification">
                  <div className="notification-description">
                    {item.description}
                  </div>
                  <div className="notification-comments">
                    {item.comment.map((comment, index) => {
                      return (
                        <div className="notification-comment">
                          <div className="notification-comment-name">
                            {comment.name}
                          </div>
                          <div className="notification-comment-text">
                            {comment.text}
                          </div>
                          <div className="notification-comment-date">
                            {comment.date}
                          </div>
                        </div>
                      );
                    })}
                    {/*<div className="notification-add-comment">
                      <textarea rows={2}></textarea>
                  </div>*/}
                  </div>
                  <div className="notification-users-visible">
                    <div className="notification-users-active">
                      {item.notifyUsers.map((user, index) => {
                        if (user.isVisible && user.forNotify) {
                          return (
                            <div className="notification-user-active">
                              {user.name === null ? user.mail : user.name}
                            </div>
                          );
                        }
                      })}
                    </div>
                    <div className="notification-users-notactive">
                      {item.notifyUsers.map((user, index) => {
                        if (!user.isVisible && user.forNotify) {
                          return (
                            <div
                              className="notification-user-notactive"
                              key={index}
                            >
                              {user.name === null ? user.mail : user.name}
                              <div className="wraper-notification-ring">
                                <div className="notification-ring">
                                  <NotificationsOutlinedIcon />
                                </div>
                                <div className="notification-message">
                                  <img src={picture1} alt=""></img>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        {selectedNotification && <div className="scroll-navbar"></div>}
      </div>
    </>
  );
};

export default NotificationList;
